// Single source of truth for user-visible product name.
// Swap this constant to rebrand the login screen / sidebar title.
export const APP_NAME = "Field Service";
export const APP_TAGLINE = "Machine Servicing Ops";
